import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-confirmation',
  template: `
    <section>
      <article class="content__image">
        <img [src]="img">
      </article>
      <article class="content__information">
        <h1>{{props.title}}</h1>
        <span>{{props.subtitle || '¿Seguro que quieres realizar esta acción?'}}</span>
      </article>
      <article class="content__action">
        <button class="df-secundario df-btn-md" (click)="handlerOnReject()">Cancelar</button>
        <button class="df-primario df-btn-md" (click)="handlerOnConfirm()">{{(props.type === 'SELECTION') && 'Aceptar' || 'Eliminar'}}</button>
      </article>
    </section>
  `,
  styleUrls: ['./confirmation.component.scss'],
  standalone: true,

})
export class ModalConfirmationComponent {

  public img = '';

  constructor(
    private dialogRef: MatDialogRef<ModalConfirmationComponent>,          
    @Inject(MAT_DIALOG_DATA) public props: Props
  ) { 
    this.img = `assets/media/svg/i_${ this.props.type === 'SELECTION' && 'confirmation' || 'delete' }.svg`;
  }

  handlerOnConfirm(){
    this.dialogRef.close({
      confirm: true
    })
  }

  handlerOnReject(){
    this.dialogRef.close({
      confirm: !true
    })
  }

}

export const SELECTION = "SELECTION";
export const DELETE = "DELETE";

type SELECTION = typeof SELECTION;
type DELETE = typeof DELETE;

interface Props{
  type: SELECTION | DELETE;
  title: string;
  subtitle?: string;
}

export type TYPE_MODAL = SELECTION | DELETE;